import { AfterViewInit, ApplicationRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CastingActions, CastingSelectors } from '@health-house/features/cast';
import { YoutubeVideoPlayerService } from '@health-house/features/video-player';
import { CastingHubService } from '@health-house/shared/api';
import { Store } from '@ngxs/store';
import { filter, from, map, Subscription, switchMap, TeardownLogic } from 'rxjs';

@Component({
  standalone: true,
  imports: [RouterModule],
  selector: 'shareview-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [YoutubeVideoPlayerService],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly applicationRef = inject(ApplicationRef);
  private readonly castingHubService = inject(CastingHubService);
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  private readonly _subscription = new Subscription();

  private set subscription(teardown: TeardownLogic) {
    this._subscription.add(teardown);
  }

  public ngOnInit(): void {
    // Force a tick to resume when Tizen restores the app to foreground.
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        this.applicationRef.tick();
      }
    });

    this.subscription = this.castingHubService.sessionStarted$
      .pipe(
        map(() => this.router.navigate(['/cast'])),
        switchMap(promise => from(promise))
      ).subscribe();

    this.subscription = this.castingHubService.sessionEnded$
      .pipe(
        map(() => this.router.navigate(['/home'])),
        switchMap(promise => from(promise))
      ).subscribe();

    this.subscription = this.castingHubService.changeLayout$.subscribe(data => console.log('ChangeLayout', data));
  }

  public async ngAfterViewInit(): Promise<void> {
    this.store.dispatch(new CastingActions.Reset());

    await this.castingHubService.connect();

    this.subscription = this.store.select(CastingSelectors.sessionId)
      .pipe(
        filter(sessionId => sessionId !== null),
        map(sessionId => sessionId as string),
        map(sessionId => this.castingHubService.join(sessionId)),
        switchMap(promise => from(promise))
      ).subscribe();

    // TODO Make this dynamic
    const sessionId = '59ff3bf0-9fdc-4d76-aa31-42ccc0e47d47';

    this.store.dispatch(new CastingActions.JoinSession(sessionId));
  }

  public async ngOnDestroy(): Promise<void> {
    await this.castingHubService.disconnect();

    this._subscription.unsubscribe();
  }
}
